export const APP = {
  SWITCH_UI_VERSION: 'SWITCH_UI_VERSION',
  FORM_IS_FETCHING: 'FORM_IS_FETCHING',
}
